if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        const spinner = opener.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const productUrl = opener.getAttribute('data-product-url');
        if (!productUrl) {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
          return;
        }

        fetch(productUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            if (!this.productElement) return;
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());

        // Keep quick-view focused on purchase context only.
        this.productElement.querySelectorAll('.jj-product-details, .jj-mobile-buy, .jj-mobile-buy-spacer').forEach((node) => {
          node.remove();
        });

        // When main product layout duplicates gallery wrappers for desktop/mobile,
        // normalize to one media column in quick-view.
        const mainProduct = this.productElement.querySelector('.jj-pdp');
        if (mainProduct) {
          const mediaWrappers = Array.from(mainProduct.children).filter((child) =>
            child?.classList?.contains('product__media-wrapper')
          );
          const infoWrappers = Array.from(mainProduct.children).filter((child) =>
            child?.classList?.contains('product__info-wrapper')
          );

          const primaryMedia = mediaWrappers[0] || null;
          const primaryInfo = infoWrappers[0] || null;

          if (primaryMedia) {
            primaryMedia.classList.remove('small-hide', 'medium-hide', 'large-up-hide');
          }
          if (primaryInfo) {
            primaryInfo.classList.remove('small-hide', 'medium-hide', 'large-up-hide');
          }

          if (mediaWrappers.length > 1) {
            mediaWrappers.slice(1).forEach((node) => node.remove());
          }
          if (infoWrappers.length > 1) {
            infoWrappers.slice(1).forEach((node) => node.remove());
          }
        }

        Array.from(this.productElement.children).forEach((child) => {
          if (child?.classList?.contains('product__media-wrapper')) {
            child.remove();
          }
        });
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}

// Fallback product-card action bindings.
// Keeps icons/buttons functional even if other global handlers fail.
(() => {
  if (window.__jjCardActionsBound) return;
  window.__jjCardActionsBound = true;

  const wishlistKey = 'jjtraderny:wishlist';

  const readWishlist = () => {
    try {
      return JSON.parse(window.localStorage.getItem(wishlistKey) || '[]');
    } catch (error) {
      return [];
    }
  };

  const writeWishlist = (handles) => {
    try {
      window.localStorage.setItem(wishlistKey, JSON.stringify(handles));
      return true;
    } catch (error) {
      return false;
    }
  };

  const syncWishlistButtons = (root = document) => {
    const handles = new Set(readWishlist());
    root.querySelectorAll('[data-jj-wishlist][data-product-handle]').forEach((button) => {
      const active = handles.has(button.dataset.productHandle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const quickViewButton = target.closest('[data-jj-quick-view][data-product-url]');
      if (quickViewButton) {
        event.preventDefault();
        event.stopPropagation();

        const modalId = quickViewButton.dataset.jjQuickViewModal;
        const modal = modalId ? document.getElementById(modalId) : null;
        if (modal && typeof modal.show === 'function') {
          modal.show(quickViewButton);
          return;
        }

        window.location.assign(quickViewButton.dataset.productUrl);
        return;
      }

      const wishlistButton = target.closest('[data-jj-wishlist][data-product-handle]');
      if (wishlistButton) {
        event.preventDefault();
        event.stopPropagation();

        const current = new Set(readWishlist());
        const handle = wishlistButton.dataset.productHandle;
        if (!handle) return;

        if (current.has(handle)) current.delete(handle);
        else current.add(handle);

        const next = Array.from(current);
        const active = current.has(handle);
        wishlistButton.classList.toggle('is-active', active);
        wishlistButton.setAttribute('aria-pressed', active ? 'true' : 'false');

        if (writeWishlist(next)) {
          syncWishlistButtons();
        }
        return;
      }

      const addTrigger = target.closest('[data-jj-add-trigger]');
      if (addTrigger) {
        event.preventDefault();
        event.stopPropagation();

        const submit = document.getElementById(addTrigger.dataset.jjAddTrigger);
        if (submit) submit.click();
      }
    },
    true
  );

  document.addEventListener('DOMContentLoaded', () => syncWishlistButtons());
  document.addEventListener('shopify:section:load', (event) => syncWishlistButtons(event.target || document));
})();
